define('PaymentModeSelectionBoardView',['underscore','backbone','app','SubView','InputView',
    'template!blocks/paymentmodes/board-wrapper'
    ],function(_,Backbone,app,SubView,InputView,
               dialogWrapperTemplate){
    return Backbone.View.extend(SubView).extend({
        className:'payment-mode__selection__modal__board',
        eventsOverride:{},
        useSubmitButton:false,
        name:'default',
        classlist:'',
        events:function(){
            return _(this.eventsOverride).defaults({
                'submit .inner__form':'submitForm',
            });
        },
        initialize:function(options){
            var view = this;
            view.subviews = [];
            _(view).extend(options);
            view.beforeRender();
            view.render();
        },
        beforeRender:function(){},
        renderInner:function(){
            return _.template('default')();
        },
        render:function(){
            var view = this,
                templateOptions = {
                    classlist:view.classlist,
                    name:view.name,
                    useSubmitButton:view.useSubmitButton,
                    inner:view.renderInner()
                };
            view.$el.html(dialogWrapperTemplate(templateOptions));
            view.afterRender();
            InputView.initializeInputsOfView(view);
        },
        afterRender:_.noop,
        submitForm:_.noop,
        close:function(){
            var view = this;
            view.trigger('close',view);
        }
    });
});
